//Core modules
import React,{Fragment} from "react";

//Internel
import { Col, Row} from "react-bootstrap";

//External
import ListBox from "../../../Common/ListBox";
import requestApi from "../../../services/requestApi.service";
import CustomForms from "./CustomForms";
import { getFormNameandLabel } from "../../../Common/Appcommon";

class CustomFormsContainer extends React.Component{

    serverUrl = process.env.REACT_APP_SERVER_URL;

    constructor(props){
        super(props);
        this.state={
            formdata : [],
            selectedForm : "",
            selectedLabel : "",
        }
    }

    componentDidMount(){
        this.getCustomizedForm();
    }

    getCustomizedForm = async () => {

        let isEnabledList = {
            "isAddonEnabled" : true, 
            "isWsappEnabled" : false, 
            "isProfileEnabled" : true,
            "type" : "Custom Forms",
            "isContactRef" : true
        };

        let response = await getFormNameandLabel(isEnabledList);
        if(response.issuccess){

            let data = response.data;
            let formList = [];

            data.map((val, index) => {
                let image = val.image;
                let imageUrl = "";
                let imageArr = image.split(".")

                if(imageArr[0] !== undefined && imageArr[0] !== "ficon" && imageArr[1] !== undefined && imageArr[1] !== ""){
                    imageUrl = this.serverUrl + "/Content/images/" + image;
                }else if(imageArr[0] !== undefined && imageArr[0] === "ficon" && imageArr[1] !== undefined && imageArr[1] === "png"){
                    imageUrl = "fa-brands fa-wpforms";
                }else{
                    imageArr = image.split("-");
                    if(imageArr[0] === 'fa' && imageArr[1] !== undefined && imageArr[1] !== ""){
                        imageUrl = image;
                    }else if(imageArr[0] === 'pe' && imageArr[1] === '7s'){
                        // pe-7s-test
                        imageUrl = image;
                    }
                }

                formList[index] = {
                    image : imageUrl,
                    crname : val.value,
                    desc : val.label,
                    clickBox : true,
                    type : "Custom_Forms"
                };
            })

            this.setState({
                formdata : formList
            })
        }
    }

    onExploreAction = (e, formname, label) => {
        this.setState({
            selectedForm : formname,
            selectedLabel : label,
        })
    }
    
    onBackAction = (e) => {
        this.setState({
            selectedLabel : "",
            selectedForm : "",
        })
       // window.location = "#/settings/customforms";
    }

    render(){
        if(this.state.selectedForm !== "" && this.state.selectedLabel !== ""){
            return (
                <>
                    <CustomForms withHeader={false} label={this.state.selectedLabel} formname={this.state.selectedForm} onBackAction = {this.onBackAction}/>
                </>
            );
        }
        return(
            <>
                <Fragment>
                    <div className={'setup-integration'}>
                        <div className={"col-md-12 integration-container custom-form-container"}>
                            <Row>
                                {
                                    this.state.formdata != undefined &&
                                    this.state.formdata.map((value)=>{
                                        return (
                                            <ListBox onExploreAction={this.onExploreAction} ListData={value}/>
                                        );
                                    })
                                }
                            </Row>
                        </div>
                    </div>
                </Fragment>
            </>
        )
    }
}
export default CustomFormsContainer;